module.exports = __webpack_public_path__ + "img/logo1.f1e48f37.png";